module.exports = __webpack_public_path__ + "img/home_cpq.93d2b6e4.png";